import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Swup from 'swup';
import swupRenderPage from './swupRenderPage.js';
//import multipleselect from 'multiple-select';
import $ from 'jquery';

//import '../components/plugin-multiselect/jquery.multi-select.js';
import '../components/plugin-multipleselect/multiple-select.js';

import '../components/show-more/show-more.js';
import '../components/form/form.js';
import '../components/header/header.js';
import '../components/form/_sharelikes.js';
import '../components/card-product/card-product.js';
import '../components/popover-search/popover-search.js';
import '../components/product-list/product-list.js';
import '../components/scrollable-slider/scrollable-slider.js';
import '../components/main-content/main-content.js';
import '../components/product-page/product-page.js';
import '../components/producers-results-head/producers-results-head.js';
import '../components/content2col/content2col.js';
import '../components/page-contact/page-contact.js';
import '../components/same-height/same-height.js';
import '../components/js-create-image/js-create-image.js';

// loads the Icon plugin
UIkit.use(Icons);
// components can be called from the imported UIkit reference
//UIkit.notification('Hello world.');

const options = {
    animateHistoryBrowsing: false,
    animationSelector: '[class*="transition-"]',
    containers: ['#swup','.swupOtherLoad'],
    cache: false,
    linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup]):not([href$="#"])',
};

const swup = new Swup(options);
swup.renderPage = swupRenderPage;
swup._handlers.loaderProgress = [];

$(function() {
  //window.dispatchEvent(new Event('px-ready'));
  //UIkit.offcanvas.hide()
  px_resize_hero();
  window.setTimeout(function(){
    jQuery('html').removeClass('is-animating')
    jQuery('html').attr('style','');
},30)
  var event;
    if(typeof(Event) === 'function') {
        event = new Event('px-ready');
    }else{
        event = document.createEvent('Event');
        event.initEvent('px-ready', true, true);
    }

    window.dispatchEvent(event);
    //UIkit.tooltip(".uk-tooltip").show();
});
swup.on('loaderProgress', function(){
    // console.log(swup.progress);
});
swup.on('contentReplaced', function(){
    window.dispatchEvent(new Event('px-ready'));
    //UIkit.offcanvas($('#mobile-menu')).hide();
    $('.uk-offcanvas').removeClass('uk-open');
    $('html').removeClass('uk-offcanvas-page');
    $('body').removeClass('uk-offcanvas-container');
    $('html,body,.uk-offcanvas').attr('style','')
    window.scrollTo(0,0);

    $('.is-back').click(function(){
        if (document.referrer.indexOf(window.location.host) !== -1) { 
            history.go(-1); return false;
        } else {  }
    })
    px_resize_hero();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event': 'registrationComplete'
    });
});

function px_resize_hero(){
    $(window).resize(function(){
        $('.px-hero').css('min-height',$('.px-hero .uk-overlay').outerHeight());
    }).trigger('resize');
    window.setTimeout(function(){$(window).trigger('resize');},100)
}
